__turbopack_context__.v({
  "active": "WVC4dG_active",
  "btn-label": "WVC4dG_btn-label",
  "btn-sort": "WVC4dG_btn-sort",
  "filter-icon": "WVC4dG_filter-icon",
  "grid-size": "WVC4dG_grid-size",
  "icon": "WVC4dG_icon",
  "orderby-icon": "WVC4dG_orderby-icon",
  "toggle-filters": "WVC4dG_toggle-filters",
  "toggle-filters-filter": "WVC4dG_toggle-filters-filter",
  "toolbar-items": "WVC4dG_toolbar-items",
  "vertical": "WVC4dG_vertical",
});
